export class TableAction {
  actionId: string;
  title: string;
  icon: string;
  enable: boolean = true;
  visible: boolean = true;
}
